export const loginClicked = {
  name: 'otp_verified',
  attributes: {
    mode: 'mode',
    mobileNumber: 'mobile_number',
    category:"category",
    url: 'url',
  },
};

export const signInClicked = {
  name: 'send_otp',
  attributes: {
    mode: 'mode',
    mobileNumber: 'mobile_number',
    category:"category",
    url: 'url',
  }
}